import React, { useEffect } from "react";
import { BrowserRouter, Link, Route, useNavigate } from "react-router-dom";
import Container from "../components/Container";
import useNavigateToSection from "../hooks/useNavigateToSection";

const Work2: React.FC = () => {
  window.scrollTo(0, 0);
  const navigateToSection = useNavigateToSection();
  return (
    <main className="content pt-40">
      <Container>
        <article className="article mx-auto">
          <div className="article-container">
            <h2 className="article-title text-center text-3xl font-bold mb-4">
              Movie Watchlist
            </h2>
            <div className="article-body grid gap-y-5">
              <div className="flex justify-center">
                <img
                  src="/movie-watchlist.png"
                  alt=""
                  className="mb-4 max-h-[50rem] object-contain"
                />
              </div>
              <p className="mt-3">
                A website where you can easily search for your favorite movies
                and build a custom watchlist just for you! The design is
                responsive thanks to Flexbox and Grid, so you can enjoy it on
                any device. By leveraging an API, it fetches all the cool movie
                data. Don't worry about losing your list; it's safely stored in
                local storage.
              </p>
              <ul className="flex gap-x-3 flex-wrap gap-y-2">
                <li className="bg-3 h-color-2 rounded-full px-2 py-1 font-semibold">
                  HTML
                </li>
                <li className="bg-3 h-color-2 rounded-full px-2 py-1 font-semibold">
                  CSS
                </li>
                <li className="bg-3 h-color-2 rounded-full px-2 py-1 font-semibold">
                  Javascript
                </li>
                <li className="bg-3 h-color-2 rounded-full px-2 py-1 font-semibold">
                  API
                </li>
              </ul>
              <div>
                <h3 className="font-bold mb-2 text-xl">URL</h3>
                <p className="mb-4">
                  <a
                    href="https://chic-cuchufli-8e64b6.netlify.app/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-blue-600 hover:text-blue-800 visited:text-purple-600"
                  >
                    https://chic-cuchufli-8e64b6.netlify.app/
                  </a>
                </p>
              </div>
              <div>
                <h3 className="font-bold mb-2 text-xl">Github Repo</h3>
                <p className="mb-4">
                  <a
                    href="https://chic-cuchufli-8e64b6.netlify.app/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-blue-600 hover:text-blue-800 visited:text-purple-600"
                  >
                    https://github.com/Mizuki-Kawabe/movie-watch-list
                  </a>
                </p>
              </div>
              <div>
                <h3 className="font-bold mb-2 text-xl">My role</h3>
                <p className="mb-4">Coding</p>
              </div>
            </div>

            <button
              className="font-bold block mx-auto my-10 h-color"
              onClick={() => navigateToSection("works")}
            >
              ← Go back to Works
            </button>
          </div>
        </article>
      </Container>
    </main>
  );
};

export default Work2;
